import { ReactNode } from 'react';

interface HeadingProps {
    level: 1 | 2 | 3 | 4 | 5 | 6;
    children: ReactNode;
}

export const Heading = ({ level, children }: HeadingProps) => {
    const Tag = `h${level}` as keyof JSX.IntrinsicElements;
    const headingClass = `text-h${level}`;

    return <Tag className={`${headingClass}`}>{children}</Tag>;
};
